import classes from "./FieldDataC.module.css";
import {  Route, Routes } from "react-router-dom";

import { useLocation } from "react-router-dom";
import Dashboard from "../Dashboard/Dashboard";

import DailyProduction from "../DailyProd/RequisitionDetails";
import DailyProductionNew from "../DailyProd/RequisitionNew";
import DailyProductionView from "../DailyProd/RequisitionView";

import RollingProduction from "../FurnanceProd/RequisitionDetails";
import RollingNew from "../FurnanceProd/RequisitionNew";
import RollingView from "../FurnanceProd/RequisitionView";

import Breakdown_details from "../breakdown/Breakdown_details";
import Breakdown_New from "../breakdown/BreakdownFeedingForm";
import RollingProductionReg from "../Register/RollingProduction";
import FurnaceProduction from "../Register/FurnaceProduction";
import BreakdownFeeding from "../Register/BreakdownFeeding";

const FieldDataS = (fieldProps) => {
  const location = useLocation();

  // console.log("Current path:", location.pathname);
  return (
    <div className={classes["Fields"]}>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />

       
        <Route
          path="/rolling-production-register"
          element={<RollingProductionReg />}
        />
        <Route
          path="/furnace_production-register"
          element={<FurnaceProduction />}
        />
        <Route path="/breakdownfeed-register" element={<BreakdownFeeding />} />
       

        <Route path="/transaction/daily-prod" element={<DailyProduction />} />

        <Route
          path="/transaction/daily-prod-new"
          element={<DailyProductionNew />}
        />
        <Route
          path="/transaction/daily_prod-view/:id"
          element={<DailyProductionView />}
        />

       

        <Route
          path="/transaction/breakdown-feeding"
          element={<Breakdown_details />}
        />
        <Route
          path="/transaction/breakdown-create"
          element={<Breakdown_New />}
        />

        <Route
          path="/transaction/furnance-detail"
          element={<RollingProduction />}
        />

        <Route path="/transaction/furnance-create" element={<RollingNew />} />
        <Route
          path="/transaction/furnance-view/:id"
          element={<RollingView />}
        />
      </Routes>
    </div>
  );
};

export default FieldDataS;
